export default __webpack_public_path__ + "static/media/bag.bd757252.svg";